module.exports = __webpack_public_path__ + "static/media/NoUserFound.2efa5a40.svg";